import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { useLenis } from "../components/site/primitives";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import { Reframe, CircleFifty, FirstGesture, HouseExtends, CareMemory, SpecialRequests, CircleProfile } from "../components/site/Sections";
import Application from "../components/site/Application";
import Footer from "../components/site/Footer";

const HOME_DESCRIPTION =
  "Hitakari House is a private, invitation-only house of hospitality across India. Founded by Samaksh Bhasin. Fifty founding members. By invite, for the circle.";

export default function HitakariHouse() {
  useLenis();
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <>
      <Helmet>
        <title>Hitakari House | Private Members' House of Hospitality, India</title>
        <meta name="description" content={HOME_DESCRIPTION} />
        <link rel="canonical" href="https://www.hitakari.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Hitakari House" />
        <meta property="og:url" content="https://www.hitakari.com/" />
        <meta property="og:title" content="Hitakari House | Private Members' House of Hospitality, India" />
        <meta property="og:description" content={HOME_DESCRIPTION} />
        <meta property="og:image" content="https://www.hitakari.com/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Hitakari House | Private Members' House of Hospitality, India" />
        <meta name="twitter:description" content="A private, invitation-only house of hospitality across India. By invite, for the circle." />
        <meta name="twitter:image" content="https://www.hitakari.com/og-image.jpg" />
      </Helmet>
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        data-testid="hitakari-page"
      >
        <Nav />
        <Hero />
        <Reframe />
        <CircleFifty />
        <FirstGesture />
        <HouseExtends />
        <CareMemory />
        <SpecialRequests />
        <CircleProfile />
        <Application />
        <Footer />
      </motion.main>
    </>
  );
}
